<template>
  <div>
    <wc-data-box
      :title='crewVisits.title'
      :titleIcon='crewVisits.icon'
      :titleIconColor='crewVisits.iconColor'
      :mini='mini'
      showHelp
      :helpText='helpText'
      :loading='isLoading'
    >
      <v-card flat v-if='visits.length === 0' >
        <v-card-text>
          {{ isLoading ? "Loading..." : "No visits found."}}
        </v-card-text>
      </v-card>
      <div :style='maxHeight ? ("max-height: " + maxHeight + "px; overflow-y: scroll;") : ""'>
        <template v-for='(v, index) in sortedVisits'>
          <v-divider v-if='index > 0' :key='v.id'></v-divider>
          <v-card flat :key="index + '-' + v.id">
            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; padding-right: 25px;">
              <div>
                <v-card-subtitle class='pb-2 d-flex align-baseline'>
                  <wc-avatar :profile='v.created_by_obj'></wc-avatar>
                  <span class='mx-2 heading-6'>{{ v.date | shortDate }}</span>
                  <small>{{ v.time | time }}</small>
                  <v-spacer></v-spacer>
                  <v-chip label class='mr-2' v-if='v.is_attempted' xSmall color='warning'>Attempted</v-chip>
                </v-card-subtitle>
                <v-card-text>
                  <span class='black--text'>{{ v.notes }}</span>
                </v-card-text>
              </div>
                <v-btn  icon @click='openFile(v.photo_obj)' v-if='v.photo_obj'>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
            </div>
          </v-card>
        </template>
      </div>
    </wc-data-box>
  </div>
</template>

<!-- If making changes to this component - be sure to also update the CrewVisitsDialog in schedule/views/scheduleDetail -->
<!-- also check out the crew visits databox on the fieldcrews/components/irrigationDetail/Overview -->

<script>
import wosAPI from '@/modules/wos/api/'
import projectsAPI from '@/modules/projects/api/projects'
import _ from 'lodash'

export default {
  name: 'wo-crew-visits',
  props: {
    wo: {
      required: false
    },
    project: {
      required: false
    },
    helpText: {
      required: false,
      type: String,
      default: "These entries are automatically added by the field crews when they complete or attempt work orders."
    },
    mini: {
      required: false,
      type: Boolean,
      default: false
    },
    maxHeight: {
      required: false,
      type: Number
    }
  },
  data: () => ({
    isLoading: true,
    visits: []
  }),
  watch: {
    'wo.id'() {
      this.getData()
    },
    'project.id'() {
      this.getData()
    }
  },
  computed: {
    crewVisits() {
      return this.$store.state.icons.dataBox.crewVisits
    },
    sortedVisits () {
      return _.orderBy(this.visits, ['date', 'time'], ['desc', 'desc'])
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      if (this.wo) {
        this.visits = await wosAPI.getCrewVisitsForWO(this.wo.id)
      } else if (this.project) {
        this.visits = await projectsAPI.getCrewVisitsForProject(this.project.id)
      }
      console.log(JSON.parse(JSON.stringify(this.visits)));
      this.isLoading = false
    },
    openFile(photo){
      window.open(photo.url, '_blank');
    }
  }
}
</script>
